<template>
  <dx-modal
    id="invoice-create-modal"
    :size="isEnabled ? 'lg' : 'md'"
    title="Emitir Nota Fiscal"
    :value="show"
    @input="close"
  >
    <template v-if="isEnabled">
      <div class="columns">
        <div
          class="column col-12 form-group"
          :class="{'has-error': $v.form.entity.name.$error}"
        >
          <label class="form-label">Tomador de serviços</label>
          <dx-autocomplete
            id="patient-name"
            v-model="entityAc"
            :readonly="!!form.entity.id"
            :source="findEntity"
            label="name"
            track-by="id"
            @select="setEntity"
            :debounce="800"
            placeholder="Nome, CPF, CNPJ ou data de nascimento"
          >
            <template v-slot:action>
              <button
                class="btn btn-action input-group-btn btn-icon"
                @click="unsetEntity"
                :class="entityAc ? 'btn-gray' : 'btn-neutral'"
                tabindex="-1"
              ><fa-icon :icon="['fal', entityAc ? 'times' : 'search']" />
              </button>
            </template>
            <template v-slot="{ item }">
              <div>{{ item.name }}</div>
              <small class="text-primary">{{ item.summary }}</small>
            </template>
          </dx-autocomplete>
          <st-form-input-hint :validator="$v.form.entity.name" />
        </div>
        <div
          class="column col-5 col-sm-12 form-group"
          :class="{'has-error': $v.form.entity.identity.value.$error}"
        >
          <label class="form-label" for="invoice-identity">Documento</label>
          <st-input-identity
            id="invoice-identity"
            :types="['cpf', 'cnpj']"
            v-model="form.entity.identity"
          />
          <st-form-input-hint :validator="$v.form.entity.identity.value" />
        </div>
        <div
          class="column col-4 col-sm-12 form-group"
          :class="{'has-error': $v.form.entity.email.$error}"
        >
          <label class="form-label" for="invoice-email">Email</label>
          <input
            type="text"
            id="invoice-email"
            class="form-input"
            v-model="form.entity.email"
            placeholder="email@email.com"
          >
          <st-form-input-hint :validator="$v.form.entity.email" />
        </div>
        <div class="column col-3 col-sm-12 form-group">
          <label class="form-label" for="invoice-email">Telefone</label>
          <input
            type="text"
            id="invoice-email"
            class="form-input"
            v-model="form.entity.phone"
            v-mask-phone.br
            placeholder="(00) 0000-0000"
          >
        </div>

        <!-- ADDRESS - INI -->
        <div
          class="column col-3 col-md-6 col-sm-12 form-group"
          :class="{'has-error': $v.form.entity.address.postalCode.$error}"
        >
          <label for="address-postal-code" class="form-label">CEP</label>
          <div class="input-group">
            <input
              type="text"
              id="address-postal-code"
              class="form-input"
              v-model="form.entity.address.postalCode"
              placeholder="00.000-000"
              @change="loadAddressByPostalCode"
              v-mask-cep
              autocomplete="nope"
            >
            <button
              type="button"
              class="btn btn-neutral btn-icon btn-action input-group-btn"
              :class="{loading: loadingAddress}"
              :disabled="loadingAddress"
            ><fa-icon :icon="['fal', 'search']"></fa-icon></button>
          </div>
          <st-form-input-hint :validator="$v.form.entity.address.postalCode" />
        </div>
        <div
          class="column col-6 col-md-12 form-group"
          :class="{'has-error': $v.form.entity.address.street.$error}"
        >
          <label for="address-addressLine1" class="form-label">Logradouro</label>
          <input
            type="text"
            id="address-addressLine1"
            class="form-input"
            v-model="form.entity.address.street"
            placeholder="Avenida Brasil"
            autocomplete="nope"
          >
          <st-form-input-hint :validator="$v.form.entity.address.street" />
        </div>
        <div
          class="column col-3 col-md-12 form-group"
          :class="{'has-error': $v.form.entity.address.number.$error}"
        >
          <label for="address-number" class="form-label">Número</label>
          <input
            type="text"
            id="address-number"
            class="form-input"
            v-model="form.entity.address.number"
            placeholder="000"
            autocomplete="nope"
          >
          <st-form-input-hint :validator="$v.form.entity.address.number" />
        </div>
        <div class="column col-3 col-md-6 col-sm-12 form-group">
          <label for="address-addressLine2" class="form-label">Complemento</label>
          <input
            type="text"
            id="address-addressLine2"
            class="form-input"
            v-model="form.entity.address.complement"
            placeholder="casa, sobrado, loja..."
            autocomplete="nope"
          >
        </div>
        <div class="column col-3 col-md-6 col-sm-12 form-group">
          <label for="address-neighborhood" class="form-label">Bairro</label>
          <input
            type="text"
            id="address-neighborhood"
            placeholder="Bairro"
            v-model="form.entity.address.neighborhood"
            class="form-input"
            autocomplete="nope">
        </div>
        <div
          class="column col-3 col-md-6 col-sm-12 form-group"
          :class="{'has-error': $v.form.entity.address.city.$error}"
        >
          <label for="address-city" class="form-label">Cidade</label>
          <input
            type="text"
            id="address-city"
            class="form-input"
            v-model="form.entity.address.city"
            placeholder="Cidade"
            autocomplete="nope"
          >
          <st-form-input-hint :validator="$v.form.entity.address.city" />
        </div>
        <div
          class="column col-3 col-md-6 col-sm-12 form-group"
          :class="{'has-error': $v.form.entity.address.state.$error}"
        >
          <label for="address-state" class="form-label">Estado</label>
          <select
            id="address-state"
            class="form-select"
            v-model="form.entity.address.state"
          >
            <option value="">[Selecione]</option>
            <option
              v-for="(text, value) in states"
              :value="value"
              :key="value"
            >{{ value }}</option>
          </select>
          <st-form-input-hint :validator="$v.form.entity.address.state" />
        </div>
        <!-- ADDRESS - END -->
      </div>

      <div class="divider" />

      <div class="columns">
        <div
          class="column col-4 col-md-6 col-sm-12 form-group"
          :class="{'has-error': $v.form.totalAmount.$error}"
        >
          <label class="form-label">Valor da nota fiscal</label>
          <div class="input-group">
            <span class="input-group-addon">R$</span>
            <dx-input-number
              class="form-input"
              maxlength="10"
              :precision="2"
              v-model="form.totalAmount"
            />
          </div>
          <st-form-input-hint :validator="$v.form.totalAmount" />
        </div>
        <div
          class="column col-4 col-md-6 col-sm-12 form-group mb-2"
          :class="{'has-error': $v.form.service.issRate.$error}"
        >
          <label class="form-label">Alíquota de ISS</label>
          <div class="input-group">
            <span class="input-group-addon">%</span>
            <dx-input-number
              class="form-input"
              v-model="form.service.issRate"
              :precision="2"
            />
          </div>
          <st-form-input-hint :validator="$v.form.service.issRate" />
        </div>
      </div>

      <div class="columns" v-if="allFields">
        <div class="column col-4 col-md-6 col-sm-12 form-group">
          <label class="form-label">IR</label>
          <div class="input-group">
            <span class="input-group-addon">%</span>
            <dx-input-number
              class="form-input"
              v-model="form.service.irRate"
              :precision="2"
            />
            <span class="input-group-addon">R$</span>
            <input
              class="form-input text-right"
              :value="formatNumber(form.service.irAmount)"
              :readonly="true"
              tabindex="-1"
            />
          </div>
        </div>
        <div class="column col-4 col-md-6 col-sm-12 form-group">
          <label class="form-label">PIS</label>
          <div class="input-group">
            <span class="input-group-addon">%</span>
            <dx-input-number
              class="form-input"
              v-model="form.service.pisRate"
              :precision="2"
            />
            <span class="input-group-addon">R$</span>
            <input
              class="form-input text-right"
              :value="formatNumber(form.service.pisAmount)"
              :readonly="true"
              tabindex="-1"
            />
          </div>
        </div>
        <div class="column col-4 col-md-6 col-sm-12 form-group">
          <label class="form-label">COFINS</label>
          <div class="input-group">
            <span class="input-group-addon">%</span>
            <dx-input-number
              class="form-input"
              v-model="form.service.cofinsRate"
              :precision="2"
            />
            <span class="input-group-addon">R$</span>
            <input
              class="form-input text-right"
              :value="formatNumber(form.service.cofinsAmount)"
              :readonly="true"
              tabindex="-1"
            />
          </div>
        </div>
        <div class="column col-4 col-md-6 col-sm-12 form-group">
          <label class="form-label">CSLL</label>
          <div class="input-group">
            <span class="input-group-addon">%</span>
            <dx-input-number
              class="form-input"
              v-model="form.service.csllRate"
              :precision="2"
            />
            <span class="input-group-addon">R$</span>
            <input
              class="form-input text-right"
              :value="formatNumber(form.service.csllAmount)"
              :readonly="true"
              tabindex="-1"
            />
          </div>
        </div>
        <div class="column col-4 col-md-6 col-sm-12 form-group">
          <label class="form-label">INSS</label>
          <div class="input-group">
            <span class="input-group-addon">%</span>
            <dx-input-number
              class="form-input"
              v-model="form.service.inssRate"
              :precision="2"
            />
            <span class="input-group-addon">R$</span>
            <input
              class="form-input text-right"
              :value="formatNumber(form.service.inssAmount)"
              :readonly="true"
              tabindex="-1"
            />
          </div>
        </div>
        <div class="column col-4 col-md-6 col-sm-12 form-group mb-2">
          <label class="form-label">Deduções</label>
          <div class="input-group">
            <span class="input-group-addon">R$</span>
            <dx-input-number
              class="form-input"
              v-model="form.deductions"
              :precision="2"
            />
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column col-sm-12 form-group mb-2"
          :class="allFields ? 'col-6' : 'col-12'"
        >
          <label class="form-label">Descrição do serviço</label>
          <textarea
            class="form-input"
            rows="3"
            v-model="form.service.description"
          />
        </div>
        <div class="column col-6 col-sm-12 form-group" v-if="allFields">
          <label class="form-label">Observações</label>
          <textarea
            class="form-input"
            rows="3"
            v-model="form.observations"
          />
        </div>
      </div>

      <div class="divider" />

      <div class="form-group pb-2">
        <span class="text-small mr-1">Código de serviço municipal:</span>
        <strong class="text-bold">{{ form.service.municipalCode }}</strong>
        <span class="m-2">|</span>
        <span class="text-small mr-1">Código NBS:</span>
        <strong class="text-bold">{{ form.service.nbsCode }}</strong>
      </div>
    </template>

    <div class="empty" v-else>
      <div class="empty-icon">
        <fa-icon :icon="['fal', 'info-circle']" size="2x"/>
      </div>
      <div class="empty-title h6">Nota Fiscal Eletrônica</div>
      <div class="empty-subtitle">
        O serviço de emissão de Nota Fiscal Eletrônica não está habilitado para sua conta.
      </div>
      <div>
        Para ativá-lo, acesse
        <router-link to="/settings">Configurações Gerais</router-link>
        → <strong>Integrações</strong>.
      </div>
      <div class="empty-action">
        <router-link
          class="btn btn-info-outline"
          to="/settings"
        >Configurar Nota Fiscal</router-link>
      </div>
    </div>

    <template v-slot:footer>
      <div class="form-group float-left">
        <label class="form-switch">
          <input type="checkbox" v-model="allFields">
          <i class="form-icon"></i> Visualizar todos os campos
        </label>
      </div>
      <button
        v-if="isEnabled"
        class="btn btn-primary mr-2"
        :class="{ loading: saving }"
        @click="save"
        :disabled="saving"
      >Emitir Nota Fiscal</button>
      <button class="btn" @click="close">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import { round } from 'lodash';
import { mapState } from 'vuex';
import { required, minValue } from 'vuelidate/lib/validators';
import states from '@/data/states';
import { CNPJ, CPF } from '@/data/identity-types';
import cpfValidator from '@/data/validators/cpf';
import cnpjValidator from '@/data/validators/cnpj';
import cpf from '@/filters/cpf';
import cnpj from '@/filters/cnpj';
import { clearNonNumbers } from '@/helpers/string';
import formatNumber from '@/filters/number';
import { extractStreetAndNumber } from '@/helpers/address';
import { first } from '@/helpers/array';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    entity: {
      type: Object,
    },
    totalAmount: {
      type: Number,
      default: 0,
    },
    issRate: {
      type: Number,
      default: 0,
    },
    irRate: {
      type: Number,
      default: 0,
    },
    pisRate: {
      type: Number,
      default: 0,
    },
    cofinsRate: {
      type: Number,
      default: 0,
    },
    csllRate: {
      type: Number,
      default: 0,
    },
    inssRate: {
      type: Number,
      default: 0,
    },
    originType: {
      type: String,
    },
    originId: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      saving: false,
      loadingAddress: false,
      form: this.blankForm(),
      entityAc: null,
      identityTypes: [CPF, CNPJ],
      allFields: false,
      formatNumber,
      states,
    };
  },
  validations() {
    const identityValidator = this.form.entity.identity.type === CPF
      ? { cpf: cpfValidator }
      : { cnpj: cnpjValidator };

    return {
      form: {
        entity: {
          name: { required },
          email: { required },
          identity: {
            value: {
              required,
              ...identityValidator,
            },
          },
          address: {
            postalCode: { required },
            street: { required },
            number: { required },
            city: { required },
            state: { required },
          },
        },
        service: {
          issRate: {
            required,
            minValue: minValue(0.01),
          },
        },
        totalAmount: {
          required,
          minValue: minValue(0.01),
        },
      },
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState({
      branch: ({ auth }) => auth.user.branch,
    }),
    settings() {
      return this.branch.settings.fiscalDocument;
    },
    isEnabled() {
      return this.settings && this.settings.enabled;
    },
    origin() {
      if (!this.originId || !this.originType) return null;
      return [this.originType, this.originId].join(':');
    },
  },
  methods: {
    async init() {
      this.loading = true;

      const entity = this.entity && this.entity.id
        ? await this.findEntityById(this.entity.id)
        : this.entity;

      this.setEntity(entity);
      this.form.totalAmount = this.totalAmount;

      this.setWatchers();

      if (this.settings) {
        if (!this.form.service.issRate) {
          this.form.service.issRate = this.settings.service.issRate;
        }
        this.form.service.municipalCode = this.settings.service.municipalCode;
        this.form.service.nbsCode = this.settings.service.nbsCode;
        this.form.service.description = this.settings.service.description;
      }

      this.loading = false;
    },
    setWatchers() {
      const percentFields = [
        'iss',
        'ir',
        'pis',
        'cofins',
        'csll',
        'inss',
      ];

      percentFields.forEach((field) => {
        const fieldRate = `${field}Rate`;
        const fieldAmount = `${field}Amount`;

        this.form.service[fieldRate] = this[fieldRate];

        this.$watch(
          `form.service.${fieldRate}`,
          () => {
            const value = this.form.totalAmount * this.form.service[fieldRate] / 100;
            this.form.service[fieldAmount] = round(value, 2);
          },
          { immediate: true },
        );
      });
    },
    async save() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }

      this.saving = true;
      try {
        await this.$http.post('/fiscal-documents', this.preparePayload());
        this.$toast.success('Nota fiscal enviada para emissão');
        this.close();
      } catch (e) {
        this.$toast.error(e);
      }
      this.saving = false;
    },
    preparePayload() {
      return {
        entity: {
          ...this.form.entity,
          identity: {
            type: this.form.entity.identity.type,
            value: clearNonNumbers(this.form.entity.identity.value),
          },
          address: {
            ...this.form.entity.address,
            postalCode: clearNonNumbers(this.form.entity.address.postalCode),
          },
          phone: clearNonNumbers(this.form.entity.phone),
        },
        service: { ...this.form.service },
        totalAmount: this.form.totalAmount,
        deductions: this.form.deductions,
        observations: this.form.observations,
        origin: this.origin,
      };
    },
    async findEntity(search) {
      const params = {
        customerId: this.branch.customerId,
        search: /^\d/.test(search) ? search : `^${search}`,
      };

      try {
        const { data } = await this.$http.get('/entities', { params });
        if (data.items.length > 0) {
          return data.items.map((item) => {
            const summaryParts = [item.type === 'person' ? 'PF' : 'PJ'];
            if (item.identity && item.identity.value) {
              summaryParts.push((
                item.type === 'person' ? cpf(item.identity.value) : cnpj(item.identity.value)
              ));
            }
            if (item.email) {
              summaryParts.push(item.email);
            }

            item.summary = summaryParts.join(' - ');
            return item;
          });
        }
      } catch (e) {
        this.$toast.error(e);
      }

      return [{
        id: null,
        name: search,
        summary: 'Não cadastrado',
      }];
    },
    async findEntityById(id) {
      try {
        const { data } = await this.$http.get(`/entities/${id}`);
        return data;
      } catch (e) {
        this.$toast.error(e);
      }
      return null;
    },
    setEntity(data) {
      if (data) {
        this.form.entity.id = data.id || null;
        this.form.entity.name = data.name;
        this.form.entity.email = data.email || '';
        this.form.entity.phone = data.cellphone || data.phone || '';

        if (data.identity && this.identityTypes.includes(data.identity.type)) {
          this.form.entity.identity = data.identity;
        } else {
          this.form.entity.identity = this.blankForm().entity.identity;
        }

        const address = first(data.addresses);
        if (address) {
          const { street, number } = extractStreetAndNumber(address.addressLine1);
          this.form.entity.address.postalCode = address.postalCode;
          this.form.entity.address.street = street;
          this.form.entity.address.number = number;
          this.form.entity.address.complement = address.addressLine2;
          this.form.entity.address.neighborhood = address.neighborhood;
          this.form.entity.address.city = address.city;
          this.form.entity.address.state = address.state;
        }

        if (this.entity.name) {
          this.form.entity.name = this.entity.name;
          this.entityAc = {
            id: this.entity.id || null,
            name: this.entity.name,
          };
        }
      } else {
        this.form.entity = this.blankForm().entity;
      }
    },
    unsetEntity() {
      this.setEntity(null);
      this.entityAc = null;
    },
    async loadAddressByPostalCode() {
      const postalCode = clearNonNumbers(this.form.entity.address.postalCode);

      if (postalCode.length === 8 && !this.loadingAddress) {
        this.loadingAddress = true;
        this.postCodeValidated = false;

        try {
          const data = await this.$cep.get(postalCode);
          this.form.entity.address.city = data.city;
          this.form.entity.address.state = data.state;
          this.form.entity.address.neighborhood = data.neighborhood;
          this.form.entity.address.street = data.street;
        } catch (e) {
          this.$toast.error(e);
        }

        this.loadingAddress = false;
      }
    },
    close() {
      this.$emit('close');
    },
    blankForm() {
      return {
        entity: {
          id: null,
          personType: 'person',
          name: '',
          identity: {
            type: CPF,
            value: '',
          },
          email: '',
          phone: '',
          address: {
            postalCode: '',
            street: '',
            number: '',
            complement: '',
            neighborhood: '',
            city: '',
            state: '',
          },
        },
        service: {
          municipalCode: '',
          nbsCode: '',
          description: '',
          issWithheldAtSource: false,
          issRate: 0,
          issAmount: 0,
          cofinsRate: 0,
          cofinsAmount: 0,
          csllRate: 0,
          csllAmount: 0,
          inssRate: 0,
          inssAmount: 0,
          irRate: 0,
          irAmount: 0,
          pisRate: 0,
          pisAmount: 0,
        },
        totalAmount: 0,
        deductions: 0,
        observations: '',
      };
    },
  },
};
</script>
